export const transactionStatus = [
	{ label: "Successful", key: "successful", value: "" },
	{ label: "Failed", key: "failed", value: "" },
	{ label: "Pending", key: "pending", value: "" },
	{ label: "Requery Transactions", key: "wasRequeried", value: "" },
];

export const transactionParams = [
	{ label: "Terminal Id", key: "terminalId", value: "" },
	{ label: "Stan", key: "stan", value: "" },
	{ label: "Reference", key: "reference", value: "" },
];

export const pageLimit = [
	{ label: "20", key: "20", value: "" },
	{ label: "50", key: "50", value: "" },
	{ label: "100", key: "100", value: "" },
	{ label: "150", key: "150", value: "" },
	{ label: "200", key: "200", value: "" },
];

export const statsCards = [
	{
		type: "info",
		icon: "ti-save",
		title: "Total Transactions",
		value: "₦0",
		footerText: "All Transactions",
		footerIcon: "ti-reload",
	},
	{
		type: "primary",
		icon: "ti-wallet",
		title: "Successful",
		value: "₦0",
		footerText: "Successful Transactions",
		footerIcon: "ti-reload",
	},
	{
		type: "warning",
		icon: "ti-server",
		title: "Pending",
		value: "₦0",
		footerText: "Pending Transactions",
		footerIcon: "ti-reload",
	},
	{
		type: "danger",
		icon: "ti-pulse",
		title: "Failed",
		value: "₦0",
		footerText: "Failed Transactions",
		footerIcon: "ti-reload",
	},
];
